import {Injectable, inject} from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import {Observable, takeUntil} from 'rxjs';
import {HttpRequestTrackerService} from "../services/http-request-tracker.service";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
    private requestTracker = inject(HttpRequestTrackerService);


    intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        if(req.url.includes('api/users/me') || req.url.includes('ws') || req.url.startsWith('api/messagerie/') || req.url.startsWith('api/extras/notifications') || this.requestTracker.estHorsAnnulation(req)) {
            return next.handle(req);
        } else {
            return next.handle(req).pipe(takeUntil(this.requestTracker.onCancelPendingRequests()))
        }
    }
}
